<template>
  <div class="d-flex">
    <v-btn small icon class="mr-1" @click.stop="addDays(-7)">
      <v-tooltip top color="primary">
        <template #activator="{ on }">
          <v-icon large color="primary" v-on="on">$arrow_left</v-icon>
        </template>
        <span>{{ $t("previousWeek") }}</span>
      </v-tooltip>
    </v-btn>
    <reports-toolbar-dates-chip
      :date="startDate"
      @show-date-dialog="showDialog('setReportsOverviewDates')"
    ></reports-toolbar-dates-chip>
    <v-btn
      small
      :disabled="disableNextWeek"
      icon
      class="ml-n2"
      @click.stop="addDays(7)"
    >
      <v-tooltip top color="primary">
        <template #activator="{ on }">
          <v-icon large :color="!disableNextWeek ? 'primary' : null" v-on="on"
            >$arrow_right</v-icon
          >
        </template>
        <span>{{ $t("nextWeek") }}</span>
      </v-tooltip>
    </v-btn>
    <default-dialog
      v-if="selectedDialog"
      :show-dialog="selectedDialog.show"
      :width="selectedDialog.width"
      :title="$t(selectedDialog.titleKey)"
      :include-actions="selectedDialog.includeActions"
      @close-dialog="closeDialog"
    >
      <template #dialog-content>
        <component
          :is="selectedDialog.content"
          :ref="selectedDialog.ref"
          :show-dialog="selectedDialog.show"
          :initial-date="startDate"
          @apply-date="applyDate"
        ></component>
      </template>
    </default-dialog>
  </div>
</template>

<script>
import { addDays, format } from "date-fns";
import dialogs from "@/mixins/dialogs";
import DefaultDialog from "@/components/dialogs/DefaultDialog";
import ReportsDatePickerFilter from "@/components/dialogs/ReportsDatePickerFilter";
import ReportsToolbarDatesChip from "./ReportsToolbarDatesChip";

export default {
  name: "ReportsToolbarDates",
  components: {
    ReportsToolbarDatesChip,
    DefaultDialog,
    ReportsDatePickerFilter,
  },
  mixins: [dialogs],
  props: {
    startDate: {
      type: String,
      required: true,
    },
  },
  computed: {
    disableNextWeek() {
      return (
        format(this.startDate, "YYYY-MM-DD") >=
        format(addDays(new Date(), -12), "YYYY-MM-DD")
      );
    },
  },
  methods: {
    addDays(val) {
      const date = JSON.parse(JSON.stringify(this.startDate));
      const newStartDate = format(addDays(date, val), "YYYY-MM-DD");
      this.$emit("apply-date", newStartDate);
    },
    applyDate(date) {
      this.$emit("apply-date", date);
      this.closeDialog();
    },
  },
};
</script>
